<template>
  <PagesExhibitionsSlugComponent
    :pageData="data"
    :siblingsData="siblingsData"
  />
</template>

<script setup>
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryExhibitionEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute()) } }
  )
})

if (!data?.value?.data?.length || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

const localizedData = computed(() => i18nGetLocalizedData(baseStrapiGetAttributes(data?.value?.data)))

const filters = {
  $and: [
    {
      exhibition_type: {
        $ne: 'permanent'
      }
    },
    {
      date_start: {
        $notNull: true
      }
    },
    { date_start: { $lt: localizedData?.value?.date_start }}
  ]
}

const { data: siblingsData, error: childError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryExhibitionEntryThumbnails({...baseRouteGetPublicationStateQuery(), filters: filters, pageSize: 6}) } }
  )
})
</script>
